import { CfNewsEventsCategory } from "types/types";
import { PageExtraReference } from "components/NewsEventsRelated/types";
import { getExtraPagesReference } from "../pages";
import { graphql, useStaticQuery } from "gatsby";

export function useGetNewsEventsDetail(
  nodeLocale = "it",
  categories: string[] = [],
  limit: number | null = null,
  skip = 0,
) {
  const { allContentfulNewsEventsDetailV2 } = useStaticQuery(graphql`
    query {
      # https://www.gatsbyjs.com/docs/graphql-reference/#sort
      allContentfulNewsEventsDetailV2(sort: { publishDate: DESC }) {
        nodes {
          ... on ContentfulNewsEventsDetailV2 {
            ...NewsEventsDetailPreviewV2
          }
        }
      }
    }
  `);

  const pages = allContentfulNewsEventsDetailV2.nodes;

  let currentPages: PageExtraReference[] = [];

  // FILTER LANG
  currentPages = pages.filter((page: PageExtraReference) => {
    if (page.node_locale !== nodeLocale) {
      return false;
    }
    return page;
  });

  let currentPagesExtra = getExtraPagesReference(currentPages) || [];

  // FILTER CATEGORY
  if (categories.length > 0) {
    currentPagesExtra = currentPagesExtra.filter((page) => {
      if (page.categories) {
        let hasCategory = false;
        page.categories.forEach((cat: CfNewsEventsCategory) => {
          if (categories.includes(cat.slug)) {
            hasCategory = true;
          }
        });
        if (hasCategory) {
          return page;
        }
      }
      return false;
    });
  }

  const totalPagesInLocal = currentPagesExtra.length;

  if (limit) {
    currentPagesExtra = currentPagesExtra.slice(skip, limit);
  }

  return {
    list: currentPagesExtra,
    total: totalPagesInLocal,
  };
}
